export const REST_API = "https://bp6j0oaukl.execute-api.eu-west-1.amazonaws.com/dev/bookings/" // PROD (named as dev env in amplify)
// export const REST_API = "https://vn8745agog.execute-api.eu-west-1.amazonaws.com/preprod/bookings"; // pre prod
// export const REST_API = "http://localhost:3001/bookings"; // local
export const BUSINESS_ID = "e0d51e18-0448-4b1f-b2af-bf8adf7174b7"